
/*
 * PAWS & PEARLS
 * SECRET SKY — LITTLE BIRD CHIRPS V1
 *
 * Independent audio companion.
 * Observes the existing roof/terrace bird.
 * Does not change her animation.
 *
 * Keeps the existing House sound system,
 * Chocolate Waltz, wind and daylight
 * birdsong untouched.
 */

(function () {
  'use strict';

  var stage = document.getElementById(
    'pp-muse-balloon-stage'
  );

  var balloon = stage &&
    stage.querySelector('button.pp-balloon');

  if (
    !stage ||
    !balloon ||
    stage.dataset.ppRoofBirdChirpsV1 === '1'
  ) return;

  stage.dataset.ppRoofBirdChirpsV1 = '1';

  var AUDIO_URL =
    'https://cdn.shopify.com/s/files/1/0784/0831/9166/files/233254__alegemaate__single-bird-chirp-2.mp3?v=1793171693';

  // Our initial gentle volume.
  var PEAK_VOLUME = 0.10;

  // Practically inaudible between calls.
  var IDLE_VOLUME = 0.001;

  // Provisional end of daytime calls.
  var DAYLIGHT_END_MS = 52000;

  // Irregular, slow intervals between calls.
  var PAUSES_MS = [
    16000,
    19000,
    14500,
    21000
  ];

  // Only these existing bird poses may chirp.
  var PERCHED = {
    'roof-perch': true,
    'terrace-look': true,
    'right-hand-pause': true,
    'roof-rest': true
  };

  var audio = null;
  var running = false;
  var disposed = false;
  var ticker = 0;
  var startedAt = 0;
  var nextAt = 0;
  var pauseIndex = 0;
  var previouslyVisible = false;
  var calling = false;
  var callStartedAt = 0;

  function houseAllowsSound() {
    var house = window.ppHouseSound;

    if (
      !house ||
      typeof house.isEnabled !== 'function'
    ) return false;

    try {
      return house.isEnabled() === true;
    } catch (_error) {
      return false;
    }
  }

  function birdReadyToChirp() {
    var controller =
      window.ppMuseRoofTerraceBirdV1;

    if (
      !controller ||
      typeof controller.getStatus !== 'function'
    ) return false;

    var state;

    try {
      state = controller.getStatus();
    } catch (_error) {
      return false;
    }

    if (
      !state ||
      !state.present ||
      !state.ready ||
      !state.visible ||
      !PERCHED[state.phase]
    ) return false;

    var bird = document.querySelector(
      '#pp-muse-roof-terrace-bird-v1 .pp-roof-terrace-bird-actor'
    );

    if (!bird || !bird.isConnected) {
      return false;
    }

    var css = window.getComputedStyle(bird);

    if (
      css.display === 'none' ||
      css.visibility === 'hidden'
    ) return false;

    // The Secret Sky may be visible while
    // the little bird herself is offscreen.
    // Check her actual rendered position.

    var rect = bird.getBoundingClientRect();

    var wrapper = document.querySelector(
      '.page-wrapper'
    );

    var bounds = wrapper
      ? wrapper.getBoundingClientRect()
      : {
          left: 0,
          top: 0,
          right: window.innerWidth,
          bottom: window.innerHeight
        };

    var left = Math.max(0, bounds.left);
    var right = Math.min(
      window.innerWidth,
      bounds.right
    );

    var top = Math.max(0, bounds.top);
    var bottom = Math.min(
      window.innerHeight,
      bounds.bottom
    );

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.right > left &&
      rect.left < right &&
      rect.bottom > top &&
      rect.top < bottom
    );
  }

  function stop() {
    running = false;
    calling = false;
    previouslyVisible = false;

    if (ticker) {
      clearInterval(ticker);
      ticker = 0;
    }

    if (audio) {
      try {
        audio.pause();
        audio.currentTime = 0;
        audio.volume = IDLE_VOLUME;
      } catch (_error) {
        // No impact on other House audio.
      }
    }
  }

  function update() {
    if (!running || disposed) return;

    if (
      !houseAllowsSound() ||
      document.hidden
    ) {
      stop();
      return;
    }

    var now = performance.now();

    if (
      now - startedAt >= DAYLIGHT_END_MS
    ) {
      stop();
      return;
    }

    var visible = birdReadyToChirp();

    if (!visible) {
      calling = false;

      if (audio) {
        audio.volume = IDLE_VOLUME;
      }

      previouslyVisible = false;
      return;
    }

    if (!previouslyVisible) {
      nextAt = Math.max(
        nextAt,
        now + 1800
      );

      previouslyVisible = true;
    }

    if (calling) {
      var ms = now - callStartedAt;

      var clipMs =
        audio &&
        isFinite(audio.duration) &&
        audio.duration > 0
          ? Math.min(
              900,
              Math.max(
                350,
                audio.duration * 1000 - 80
              )
            )
          : 850;

      if (ms >= clipMs) {
        calling = false;
        audio.volume = IDLE_VOLUME;
      } else {
        // Gentle attack and release.
        var rise = Math.min(
          1,
          ms / 100
        );

        var fall = Math.min(
          1,
          (clipMs - ms) / 160
        );

        audio.volume =
          IDLE_VOLUME +
          (PEAK_VOLUME - IDLE_VOLUME) *
          Math.max(
            0,
            Math.min(rise, fall)
          );
      }

      return;
    }

    if (now >= nextAt) {
      try {
        // Restart the actual chirp.
        // The audio was authorised by
        // the balloon click.

        audio.currentTime = 0;
        audio.volume = IDLE_VOLUME;

        callStartedAt = now;
        calling = true;

        nextAt =
          now +
          PAUSES_MS[
            pauseIndex % PAUSES_MS.length
          ];

        pauseIndex++;

      } catch (_error) {
        // A missed chirp must never
        // interrupt the Secret Sky.
      }
    }
  }

  function onBalloonClick() {
    if (
      disposed ||
      running ||
      !houseAllowsSound()
    ) return;

    if (
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) return;

    if (!audio) {
      audio = new Audio(AUDIO_URL);
      audio.preload = 'auto';
      audio.loop = true;
    }

    try {
      audio.pause();
      audio.currentTime = 0;
      audio.volume = IDLE_VOLUME;

      startedAt = performance.now();

      nextAt = startedAt + 1800;

      pauseIndex = 0;
      previouslyVisible = false;
      calling = false;
      running = true;

      // Start audio within the visitor click
      // to satisfy Safari's gesture rules.
      // It remains virtually silent between
      // the little bird's individual calls.

      var attempt = audio.play();

      if (
        attempt &&
        typeof attempt.catch === 'function'
      ) {
        attempt.catch(function () {
          if (running) stop();
        });
      }

      ticker = setInterval(update, 60);

    } catch (_error) {
      stop();
    }
  }

  function onHouseSoundChange() {
    if (!houseAllowsSound()) stop();
  }

  function onVisibilityChange() {
    if (document.hidden) stop();
  }

  function onSectionUnload(event) {
    if (
      !event ||
      !event.target ||
      !event.target.contains(stage)
    ) return;

    disposed = true;
    stop();

    balloon.removeEventListener(
      'click',
      onBalloonClick
    );

    document.removeEventListener(
      'pp:house-sound-change',
      onHouseSoundChange
    );

    window.removeEventListener(
      'pp:house-sound-change',
      onHouseSoundChange
    );

    document.removeEventListener(
      'visibilitychange',
      onVisibilityChange
    );

    document.removeEventListener(
      'shopify:section:unload',
      onSectionUnload
    );

    window.removeEventListener(
      'pagehide',
      stop
    );
  }

  balloon.addEventListener(
    'click',
    onBalloonClick
  );

  document.addEventListener(
    'pp:house-sound-change',
    onHouseSoundChange
  );

  window.addEventListener(
    'pp:house-sound-change',
    onHouseSoundChange
  );

  document.addEventListener(
    'visibilitychange',
    onVisibilityChange
  );

  document.addEventListener(
    'shopify:section:unload',
    onSectionUnload
  );

  window.addEventListener(
    'pagehide',
    stop
  );

})();
